import Splide from '@splidejs/splide';
import Classes from '../utils/custom-classes';
import FindItems from '../utils/find-items';

export default class CarouselPlans {
  constructor(scope) {
    const target = '[data-carousel-plans]';

    FindItems(scope, target, this.create);
  }

  create(element) {
    new Splide(element, {
      type: 'slide',
      drag: true,
      arrows: false,
      classes: Classes,
      perMove: 1,
      trimSpace: false,
      autoHeight: true,
      slideFocus: false,
      destroy: true,
      focus: 'center',
      breakpoints: {
        1260: {
          destroy: false,
          fixedWidth: '390px'
        },
        567: {
          fixedWidth: '260px'
        }
      }
    }).mount();
  }
}
